import type { CSSProperties, ReactElement } from 'react';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Ctext } from '../Ctext';
import { CTEXTINPUT_ERROR_FONT_SIZE_PX, CTEXTINPUT_TEXT_ACTIVE_OPACITY, CtextinputDataName, } from './Ctextinput.constants';
interface CtextinputErrorTextProps {
    errorText: string;
    style: CSSProperties;
}
export function CtextinputErrorText({ errorText, style, }: CtextinputErrorTextProps): ReactElement {
    return (
    <div style={style}>
	      <Ctext size={CTEXTINPUT_ERROR_FONT_SIZE_PX} weight={FontWeight.Regular} color={ColorType.Danger} opacity={CTEXTINPUT_TEXT_ACTIVE_OPACITY}>
        {errorText}
      </Ctext>
    </div>
    );
}
